import React from "react";
import clsx from "clsx";

import { RiSendPlaneFill } from "react-icons/ri"
import { ICONS } from "../constants";

const Header = ({
  paginate,
  pageSizeOptions,
  searchableFields,
  paginationState,
  filterState,
  showAddForm,
  noAction,
  updatePagination,
  onFilterChange,
  onAdd,
  onSync,
  isSyncInProgress
}) => {
  return (
    <div className={clsx("datatable_header", { "no-action": noAction })}>
      {paginate && pageSizeOptions.length > 1 && (
        <div className="datatable_pagesize">
          <span>Show</span>
          <select
            value={paginationState.pageSize}
            disabled={showAddForm}
            onChange={({ target }) =>
              updatePagination("pageSize", parseInt(target.value))
            }
          >
            {pageSizeOptions.map((size) => (
              <option value={size} key={size} children={size} />
            ))}
          </select>
          <span>entries</span>
        </div>
      )}

      {onSync && (
        <div className={clsx("datatable_add", { open: showAddForm })}>
          <div className='tooltip'>
            <div className="tooltiptext">Send all</div>
            <span className={clsx({ spin: isSyncInProgress })} children={isSyncInProgress ? <ICONS.Spinner /> : <RiSendPlaneFill />} onClick={onSync} />
          </div>
        </div>
      )}

      {onAdd && (
        <div className={clsx("datatable_add", { open: showAddForm })}>
          <div className='tooltip'>
            <div className="tooltiptext">Add new</div>
            <span children={<ICONS.Plus />} onClick={() => onAdd(!showAddForm)} />
          </div>
        </div>
      )}



      {searchableFields.length > 0 && (
        <div className="datatable_search">
          <span>Search: </span>
          <input
            type="search"
            value={filterState.search}
            placeholder="Start typing here..."
            onChange={({ target }) => onFilterChange("search", target.value)}
            disabled={showAddForm}
          />
        </div>
      )}
    </div>
  );
};

export default Header;
